<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-10">
        <div class="container">
          <div class="text-center pb-3 pt-4">
            <h3>Solicite um Orçamento</h3>
          </div>
        </div>
        <div>
          <form>
            <div class="row justify-content-center">
              <div class="form-group col-md-7">
                <label for="nome">Nome</label>
                <input
                  type="text"
                  class="form-control"
                  id="nome"
                  v-model="nome"
                  autocomplete="off"
                />
                <div
                  class="mt-1 alert alert-danger"
                  v-if="$v.nome.$invalid && submitClicked"
                >
                  <span v-if="!$v.nome.required">Campo Obrigatório!</span>
                </div>
              </div>
              <div class="form-group col-md-5">
                <label for="telCel">Telefone/Celular</label>
                <input
                  type="text"
                  class="form-control"
                  id="telCel"
                  v-model="telCel"
                  autocomplete="off"
                />
                <div
                  class="mt-1 alert alert-danger"
                  v-if="$v.telCel.$invalid && submitClicked"
                >
                  <span v-if="!$v.telCel.required">Campo Obrigatório!</span>
                  <span v-if="!$v.telCel.minLength"
                    >Mínimo {{ $v.telCel.$params.minLength.min }} caracteres
                    (DDD Número).</span
                  >
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="email">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  v-model="email"
                  autocomplete="off"
                />
                <div
                  class="mt-1 alert alert-danger"
                  v-if="$v.email.$invalid && submitClicked"
                >
                  <span v-if="!$v.email.required">Campo Obrigatório!</span>
                  <span v-if="!$v.email.email">Formato inválido!</span>
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="assunto">Assunto</label>
                <input
                  type="text"
                  class="form-control"
                  id="assunto"
                  v-model="assunto"
                  autocomplete="off"
                />
                <div
                  class="mt-1 alert alert-danger"
                  v-if="$v.assunto.$invalid && submitClicked"
                >
                  <span v-if="!$v.assunto.required">Campo Obrigatório!</span>
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="mensagem">Mensagem</label>
                <textarea
                  type="text"
                  class="form-control"
                  id="mensagem"
                  v-model="mensagem"
                  autocomplete="off"
                />
                <div
                  class="mt-1 alert alert-danger"
                  v-if="$v.mensagem.$invalid && submitClicked"
                >
                  <span v-if="!$v.mensagem.required">Campo Obrigatório!</span>
                  <span v-if="!$v.mensagem.minLength"
                    >Mínimo
                    {{ $v.mensagem.$params.minLength.min }} caracteres.</span
                  >
                </div>
              </div>
              <div class="col-md-12 text-center">
                <input
                  type="button"
                  class="btn btn-success"
                  value="Enviar"
                  v-on:click="enviarEmail"
                  v-if="!dialog"
                />
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                  v-if="dialog"
                ></v-progress-circular>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <notifications group="naoEmail" position="bottom center" :speed="500" />
    <notifications group="enviadoEmail" position="bottom center" :speed="500" />
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      nome: "",
      telCel: "",
      email: "",
      assunto: "",
      mensagem: "",
      dialog: false,
      submitClicked: Boolean
    };
  },
  validations: {
    nome: {
      required
    },
    telCel: {
      required,
      minLength: minLength(10)
    },
    email: {
      required,
      email
    },
    assunto: {
      required
    },
    mensagem: {
      required,
      minLength: minLength(10)
    }
  },
  methods: {
    enviarEmail() {
      this.submitClicked = this.$v.$invalid;
      if (!this.$v.$invalid) {
        this.dialog = true;
        let mailOptions = {
          nome: this.nome,
          telCel: this.telCel,
          email: this.email,
          assunto: `[SKALA]: ${this.assunto}`,
          mensagem: this.mensagem
        };
        axios.post("https://www.sabios.net.br/api/orcamento", mailOptions).then(
          rs => {
            this.dialog = false;
            this.limparForm();
            this.$notify({
              group: "enviadoEmail",
              title: "Solicitação de orçamento enviado...",
              type: "success"
            });
          },
          err => {
            this.dialog = false;
            this.$notify({
              group: "naoEmail",
              title:
                "Não foi possível enviar orçamento, tente novamente mais tarde...",
              type: "error"
            });
            console.log("Error: " + err);
          }
        );
      }
    },
    limparForm() {
      this.nome = "";
      this.telCel = "";
      this.email = "";
      this.assunto = "";
      this.mensagem = "";
    }
  },
  mounted() {
    this.submitClicked = false;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Orcamento.vue